import React,{ Fragment, useEffect, useRef } from "react";
import { useThrottleFn } from "react-use";
import {
    useNavigate,
} from 'react-router';
import { useShallow } from 'zustand/react/shallow';
import {useCommonStore} from "../store/useCommonStore";
import wsClient from "../utils/wsClient";
import LoadingSpinner from "../component/LoadingSpinner";

export const RouterInitData = ({ children }) => {
    // const {inited,user} = useStore(s=>s.common);

    const { user, inited, initFn, setRouteNavigate } = useCommonStore(
        useShallow((state) => ({
            user: state.user,
            inited: state.inited,
            initFn: state.initFn,
            setRouteNavigate: state.setRouteNavigate
        }))
    );
    // const {inited, user, initFn} = commonBaseStore( s=> s);
    //console.log('routerInitData', user, inited);
    const navigate = useNavigate();
    const wsInitialized = useRef(false);

    // const { initFn } = useCommonStore( state => state.initFn);
    //console.log('initFn in routerInitData', initFn);

    useEffect(()=>{
        if(inited == false && user != null){
            console.log("useEffect initFn",inited,user);
            initFn();
        }
        setRouteNavigate(navigate);
    },[inited]);

    // 初始化完成后，建立全局 WebSocket 连接
    // 页面层无需关心连接/认证细节，只管 ws.on() / ws.subscribe()
    useEffect(() => {
        if (inited && !wsInitialized.current) {
            // 从 user 对象中提取 WebSocket 认证凭据
            // auth 结构: { name: "Authorization值", token: "wsctoken值" }
            const auth = user?.auth;
            const wsctoken = auth?.token || user?.token;
            const authorization = auth?.name || user?.Id?.toString();
            if (wsctoken && authorization) {
                wsInitialized.current = true;
                console.log("[WS] 系统初始化全局 WebSocket 连接");
                
                // 监听状态，当认证完成后执行全量替换订阅，使状态机推进到 ready
                const unsub = wsClient.onStatusChange((status) => {
                    if (status === 'authenticated') {
                        unsub(); // 只需要执行一次
                        // adminserver 初始化时订阅的基础房间，如果有企业ID等可以动态加入
                        wsClient.setupSubscriptions({ 
                            rooms: ['debug'], // 默认订阅 debug 房间
                            patterns: [] 
                        }).then(() => {
                            console.log("[WS] 全局基础订阅完成，状态变为 ready");
                        }).catch(err => {
                            console.error("[WS] 全局基础订阅失败:", err);
                        });
                    }
                });

                wsClient
                    .setCredentials(wsctoken, authorization)
                    .connect();
            }
        }
    }, [inited]);

    // return children as React.ReactElement
    return inited ? <Fragment>{children}</Fragment> : <LoadingSpinner text="系统初始化中，请稍候..." />
  }